/* global axios */
import ApiClient from './ApiClient';

class HubNotificationsAPI extends ApiClient {
  constructor() {
    super('hub_notifications', { accountScoped: true });
  }

  markAllRead() {
    return axios.post(`${this.url}/mark_all_read`);
  }

  clear() {
    return axios.delete(`${this.url}/clear`);
  }
}

export default new HubNotificationsAPI();
